import { elementHasServerLoadScript } from '@/common/utils/elementHasServerLoadScript'
import { extractUniDataTableRows } from '@/common/utils/extractUniDataTableRows'

const TABLE_TYPES = new Set(['TABLE', 'EDITABLE', 'GROUPTABLE'])

/**
 * При mount таблицы без строк вызывает reload/element, если в метаданных есть onLoad или procedure.
 */
export async function reloadEmptyTableElementOnMount(options: {
  elementType: string
  elementConfig: { element?: unknown } | null | undefined
  fieldName: string
  pageFields: Record<string, any> | null | undefined
  reload?: (
    out?: unknown,
    opts?: { applyResult?: boolean; source?: string },
  ) => Promise<unknown>
}): Promise<void> {
  const type = String(options.elementType ?? '').trim().toUpperCase()
  if (!TABLE_TYPES.has(type)) return
  if (!elementHasServerLoadScript(options.elementConfig)) return

  const fieldName = String(options.fieldName ?? '').trim()
  if (!fieldName || typeof options.reload !== 'function') return

  const existingRows = extractUniDataTableRows(options.pageFields?.[fieldName])
  if (existingRows.length > 0) return

  try {
    await options.reload({}, { applyResult: true, source: 'ElementRenderer.mountTableOnLoad' })
  } catch (err) {
    console.error(`[ElementRenderer] mount table reload failed for ${fieldName}:`, err)
  }
}
